import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { from, Observable } from 'rxjs';

import { DiscardChangesModalComponent } from '../components';
import { FormService, ModalService } from '../services';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DiscardChangesGuard {
  constructor(
    private formService: FormService,
    private modalService: ModalService,
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.formService.anyFormChanges(this.modalService.modalLevel)) {
      return true;
    }

    return from(
      this.modalService.openMedium<DiscardChangesModalComponent>(DiscardChangesModalComponent).modal.result,
    ).pipe(
      tap((discard: boolean) => {
        if (discard) {
          this.formService.resetForms(this.modalService.modalLevel);
        }
      }),
    );
  }
}
